<span class="comma-separated">
  <span *ngFor="let item of summary" class="font-body-2 regular-type ps-xxsmall-b">
    {{ item.description | finLocalization: { amount: item.quantity } }}
  </span>
</span>
